<template>
  <article>
    <div class="sm:ut-flex ut-content-between items-stretch ut--mx-4">
      <performance-premier-stats-card class="sm:ut-w-1/2"
        :title="'recommendations'"
        :stat="groupStats.shownToVendor"
        :infoText="recommendationsInfoText"
        :iconName="'icon-eye'">
        <div>
          <h4 class="ut-mb-3">Latest</h4>
          <ul class="ticker-scroll" v-if="recentLeads.length > 0">
            <li v-for="(item, index) in uniqueRecentLeads"
                :key="index"
                class="ut-flex ut-justify-start ut-content-start ut-mt-2">
              <svg-loader v-if="item.icon"
                :name="item.icon"
                :size="16"
                class="ut-m-0"></svg-loader>
              <span class="ut-m-0 ut-pl-2">{{ item.text }}</span>
            </li>
            <li v-if="groupStats.shownToVendor > 3">
              <span class="ut-m-0 ut-w-4 ut-inline-block"></span>
              <span class="ut-m-0 ut-pl-2">... and {{ groupStats.shownToVendor - 3 }} more</span>
            </li>
          </ul>
          <!-- <updates-ticker v-if="recentLeads.length > 0"
                               :tickerItems="recentLeads"
                               class="latest-leads" /> -->
        </div>
      </performance-premier-stats-card>
      <performance-premier-stats-card class="sm:ut-w-1/2"
        :title="'Referrals'"
        :stat="groupStats.referrals"
        :iconName="'icon-user-qualified'">
        <div class="ut-flex ut-content-between ut-justify-between">
          <stat-square class="ut-mr-2" :label="'Listing Referrals'" :value="groupStats.goToMarkets" :linklabel="linkLabel" :linkurl="linkURL" />
          <stat-square class="ut-ml-2" :label="'Won Listings'" :value="groupStats.listings" :linklabel="wonListingsLinkLabel" :linkurl="wonListingsLinkURL" />
        </div>
      </performance-premier-stats-card>
    </div>
</article>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import PerformancePremierStatsCard from '@/components/PerformancePremierStatsCard.vue';
import { PremierContractType } from '@/Mapper/PremierContractType';
import StatSquare from '@/components/StatSquare.vue';
import { mapState } from 'vuex';

// import SvgIcon from '@/components/SvgIcon.vue';
// import SvgLoader from '@oa/svg-loader/SvgLoader.vue';
// import UpdatesTicker from '@/components/UpdatesTicker/UpdatesTicker.vue';

export default {
  name: 'PerformancePremierSection',
  components: {
    PerformancePremierStatsCard,
    StatSquare,
    // SvgIcon,
    SvgLoader,
    // UpdatesTicker,
  },
  props: {
    groupStats: {
      required: true,
      default: null,
    },
    accountid: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      recentLeads: [],
      recommendationsInfoText: '',
      linkLabel: 'See details',
      wonListingsLinkLabel: 'See won listings'
    };
  },
  created() {
    this.getRecentLeads();
    this.getSnippets();
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    uniqueRecentLeads() {
      if (this.recentLeads && this.recentLeads.length > 0) {
        const leadsToDisplay = [];
        for (let i = 0; i < this.recentLeads.length && leadsToDisplay.length < 3; i += 1) {
          if (leadsToDisplay.findIndex(item => item.id === this.recentLeads[i].id) === -1) {
            leadsToDisplay.push(this.recentLeads[i]);
          }
        }
        return leadsToDisplay;
      }
      return [];
    },
    linkURL() {
      if(this.user.premiercontracttype === PremierContractType.VariableGTM) {
        return `/listing-referrals/${!!this.user && !!this.user.key ? `${this.user.key}` : ''}`;
      }
      return null;
    },
    wonListingsLinkURL() {
      // if(this.user.premiercontracttype === PremierContractType.VariableGTM) {
      if(this.user.premiercontracttype === PremierContractType.Hybrid) {
        return `/listing-referrals/${!!this.user && !!this.user.key ? `${this.user.key}` : ''}#won`;
      }
      return null;
    },
  },
  methods: {
    getRecentLeads() {
      this.$apiServices.oa.lead.getLeadRecommendationsForAccount(this.accountid)
        .then((recentLeadsResponse) => {
          if (recentLeadsResponse) {
            // this.recentLeads = recentLeadsResponse;

            this.recentLeads = recentLeadsResponse.map((lead) => {
              lead.icon = 'icon-house';

              if (lead.propertytype === 'Apartment') {
                lead.icon = 'icon-apartment';
              }

              if (lead.propertytype === 'Land') {
                lead.icon = 'icon-land';
              }

              lead.text = `${this.$options.filters.ago(lead.datecreated)} - ${lead.beds !== null ? `${lead.beds} bd` : ''} ${lead.propertytype} in ${lead.suburb}`;

              return lead;
            });
          }
        }, (err) => {
        // reject(err);
          console.log(err);
          this.recentLeads = [];
        });
    },
    getSnippets() {
      const data = {
        snippettitlelist: 'premier-recommendations-i-text',
      };

      this.$apiServices.oa.article.getSnippets(data)
        .then((snippets) => {
          this.recommendationsInfoText = snippets.length > 0
            ? decodeURI(snippets[0].snippetbody).replace(/<[^>]*>?/gm, '')
            : null;
        }, (err) => {
        // reject(err);
          console.log(err);
          this.recommendationsInfoText = null;
        });
    },
  },
};
</script>

<style scoped lang="scss">
  h2 {
    opacity: 0.9;
    color: #233A3A;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 28px;
    margin-bottom: 20px;
  }

  h4 {
    font-size: 14px;
    line-height: 16px;
    opacity: 0.6;
    color: #233A3A;
  }

  ul {
    color: #233A3A;

    li {
      width:100%;
      color: #8C8B89;

      span {
        font-size: 12px;
        color: #233A3A;
      }

      &.more-leads {
        color: #00ab64;
      }

    }
  }

</style>
